module.exports = __webpack_public_path__ + "static/publicapp-190b0090d99b615f3833f5bbe71133b5.mp4";